import { render, staticRenderFns } from "./GiftcardBlobControls.vue?vue&type=template&id=2363e055&scoped=true"
import script from "./GiftcardBlobControls.vue?vue&type=script&lang=js"
export * from "./GiftcardBlobControls.vue?vue&type=script&lang=js"
import style0 from "./GiftcardBlobControls.vue?vue&type=style&index=0&id=2363e055&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2363e055",
  null
  
)

export default component.exports